// extracted by mini-css-extract-plugin
module.exports = {"menu":"nav_menu__1X6gm","submenu":"nav_submenu__2FG_R","mobile-button":"nav_mobile-button__vrLPr","active":"nav_active__XFyvS"};